import {Basic} from "./Basic";
/* import {History} from "./History"; */

export class Load
{
    static post(myData)
    {
        document.documentElement.classList.add('w__waiting');
        if(!myData.url)
        {
            myData.url = document.location.pathname;
        }
        myData.time = new Date().getTime();

        return new Promise(function(resolve, reject)
        {
            const myRequest = new XMLHttpRequest();
            myRequest.timeout = 10000;
            myRequest.onreadystatechange = function()
            {
                if(myRequest.readyState === 4)
                {
                    document.documentElement.classList.remove('w__waiting');
                    if(myRequest.status === 200 && myRequest.response)
                    {
                        if(myRequest.response['status'] === 'OK')
                        {
                            resolve(myRequest.response);
                        }
                        else
                        {
                            reject(myRequest.response);
                        }
                    }
                    else
                    {
                        reject('Empty response. Status: ' + myRequest.status);
                    }
                }
            };

            myRequest.ontimeout = function()
            {
                document.documentElement.classList.remove('w__waiting');
                reject('Request timed out. Network problems?');
            };

            myRequest.open("POST",Basic.base + 'index.php');
            myRequest.setRequestHeader("Content-Type","application/x-www-form-urlencoded; charset=utf-8");
            myRequest.setRequestHeader("Accept","application/json");
            myRequest.responseType = 'json';
            myRequest.send('json=' + encodeURIComponent(JSON.stringify(myData)));
        });
    }
}

